import { useEffect } from 'react';
import PersonaRecibeForm from '../../components/personal-recibe/PersonaRecibeForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalRecibeStore,
  type RegistrarPersonaRecibe
} from '../../stores/personal-recibe/personal-recibe.store';

const AgregarPersonaRecibe = () => {
  const { current: persona, nuevo, registrar } = usePersonalRecibeStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = (values: RegistrarPersonaRecibe) => {
    return registrar(values);
  };

  return (
    <PersonaRecibeForm
      esAgregar={true}
      persona={persona}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default AgregarPersonaRecibe;
